import { MSLatLng } from 'src/app/models/map.model';

export namespace GeolocationStatus {
  export class Spec {}
  export class CurrentPosition extends Spec implements MSLatLng {
    constructor(
      public readonly lat: number,
      public readonly lng: number
    ) {
      super();
    }
  }

  export class Error extends Spec {
    constructor(public readonly message: string) {
      super();
    }
  }
}
